import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { AuthService } from './auth.service';

import { environment } from '../../environments/environment';

@Injectable()
export class AccountService {

    apiUrl = environment.apiUrl;

    constructor(private http: Http,
        private authService: AuthService) { }

    setCurrentAccount(account: any) {
        localStorage.setItem('account', JSON.stringify(account));
    }

    getCurrentAccount() {
        return JSON.parse(localStorage.getItem('account')) || {};
    }

    getAccounts(): Observable<any> {
        var token = 'Bearer ' + this.authService.getUserToken();
        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);

        return this.http.get(this.apiUrl + '/account', { headers: headers })
            .map(this.extractData)
            .catch(this.handleError);
    }

    createAccount(name: string): Observable<any> {
        var token = 'Bearer ' + this.authService.getUserToken();
        let headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('Authorization', token);

        return this.http.put(this.apiUrl + '/account', { name: name }, { headers: headers })
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body;
    }

    private handleError(error: Response | any) {
        let errMsg: any;
        if (error instanceof Response) {
            errMsg = error.json();
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
}
